import { Page, View, Text } from "@react-pdf/renderer";

import { Props } from "../../ClearOrderDocument";
import { styles } from "../styles";
import { AdditionalInformation } from "./AdditionalInformation";
import { Options } from "./Options";
import { PatientSection } from "./PatientSection";
import { ProceduresSection } from "./ProceduresSection";
import { Signature } from "./Signature";

/**
 * CLE-2659: laid out to match CMS-R-131 (Exp. 03/31/2029), the 2026 revision of the Advance
 * Beneficiary Notice of Non-coverage. The previous revision used lettered sections (A. through J.);
 * the 2026 form drops them, so the section order and headings here follow the printed form exactly.
 * Wording is CMS boilerplate — do not paraphrase it.
 */
export function MedicareDocument({
  name,
  activeAbnNotice,
  accountNumber,
  facilityName,
  fullAddress,
  phoneNumber,
}: Props) {
  return (
    <Page size="LETTER" style={styles.page}>
      {/* Left-aligned, not the shared justified body — CMS prints the form ragged-right. */}
      <View style={{ ...styles.content, textAlign: "left" }} wrap>
        <View style={styles.section}>
          <PatientSection
            name={name}
            accountNumber={accountNumber}
            facilityName={facilityName}
            fullAddress={fullAddress}
            phoneNumber={phoneNumber}
          />

          <Text style={{ ...styles.title, fontSize: 14, marginTop: 6 }}>
            Advance Beneficiary Notice of Non-coverage (ABN)
          </Text>

          <Text style={{ ...styles.bodyText, fontSize: 11, marginTop: 6 }}>
            Medicare doesn&apos;t pay for everything, even some care you or your
            health care provider think you need.{" "}
            <Text style={{ fontFamily: "Helvetica-Bold" }}>
              We expect Medicare may not pay for the item, test, service or care
              listed below.
            </Text>{" "}
            If Medicare doesn&apos;t pay, you may have to pay.
          </Text>

          <ProceduresSection activeAbnNotice={activeAbnNotice} />
          {activeAbnNotice && <Options activeAbnNotice={activeAbnNotice} />}
          {/* Deliberately blank: we collect no free-text additional information. NOT
              documentSnapshot.note, which is the "Option 1 or 2" note the options box renders. */}
          <AdditionalInformation />
          <Signature activeAbnNotice={activeAbnNotice} />
        </View>
      </View>
    </Page>
  );
}
